export var FolderType = /*#__PURE__*/ function(FolderType) {
    FolderType["Collection"] = "collection";
    FolderType["Gallery"] = "gallery";
    return FolderType;
}({});

//# sourceMappingURL=types.js.map